import React, { useState, useEffect } from 'react';
import ImageTag from '../ImageTag/Index';
import './index.css';
import BreadCrumbs from '../BreadCrumb/Index';

const Index = ({
  Data,
  positionText,
  children,
  ImageHeight = '550',
  ImageWidth = '1920',
  MobileImageHeight = '450',
  MobileImageWidth = '630',
  BannerClass = ''
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768); // Standard mobile breakpoint
    };

    // Initial check
    checkScreenSize();

    // Add event listener
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Process heading content based on screen size
  const processHeading = (content) => {
    if (!content) return '';
    if (isMobile) {
      // Remove <br> tags on mobile and replace with space
      return content.replace(/<br\s*\/?>/gi, ' ');
    }
    return content;
  };

  const processedHeading = Data?.heading ? processHeading(Data.heading) : '';

  return (
    <section className={`col-12 float-start flex-center overflow-hidden flex-wrap ${BannerClass}`
    }>
      <div className={`col-12 float-start InternalBanner position-relative ${children ? 'has-overlay' : ''}`}>
        {Data?.imagePath || Data?.mobileImagePath ? (
          <>
            <ImageTag
              ImagePath={Data.imagePath}
              ImageAlt={Data.imageAlt}
              ImageWidth={ImageWidth}
              ImageHeight={ImageHeight}
              ImageClass="desktop-show object-fit"
            />
            <ImageTag
              ImagePath={Data.mobileImagePath}
              ImageAlt={Data.imageAlt}
              ImageWidth={MobileImageWidth}
              ImageHeight={MobileImageHeight}
              ImageClass="mobile-show object-fit"
            />
          </>
        ) : (
          <div className='col-12 float-start Noimage flex-center'>
            <ImageTag ImageAlt='No Image Found' />
          </div>
        )}

        {processedHeading && (
          <span
            className={`heading position-absolute text-white greenBorder d-block px-lg-4 px-2 ${positionText}`}
            dangerouslySetInnerHTML={{ __html: processedHeading }}
          />
        )}

        {children && (
          <div className="banner-overlay-content">
            {children}
          </div>
        )}
      </div>

      <BreadCrumbs _parentClass='col-12 float-start' />
    </section >
  );
};

export default Index;